import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {LoadingController, NavController} from '@ionic/angular';
import {ApiService} from '../../services/api.service';
import {Storage} from '@ionic/storage';
import {ToastService} from '../../services/toast.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-auto-connect',
  templateUrl: './auto-connect.page.html',
  styleUrls: ['./auto-connect.page.scss'],
})
export class AutoConnectPage implements OnInit {

  constructor(private navController: NavController,
              private apiService: ApiService,
              private storage: Storage,
              private loadingController: LoadingController,
              private toastService: ToastService,
              private route: ActivatedRoute) { }

  email: string;
  timestamp: string;
  token: string;

  ngOnInit() {
    this.apiService.authApi.setToken(null);

    this.route.queryParams.subscribe(params => {
      this.email = params.email;
      this.timestamp = params.timestamp;
      this.token = params.token;
      if (this.email && this.timestamp && this.token){
        this.doLogin();
      } else {
        this.navController.navigateBack('/');
      }
    });
  }

  async doLogin() {
    const loading = await this.loadingController.create({
      spinner: 'circular'
    });

    loading.present();

    const params = {
      email : this.email,
      timestamp: this.timestamp,
      token: this.token
    };

    this.apiService.authApi.postAutoConnect(params).then((e: any) => {
      loading.dismiss();

      this.apiService.authApi.setToken(e.access_token).then((e) => {
        this.navController.navigateForward('/home');
      });
    }).catch(() => {
      this.apiService.authApi.setToken(null);

      this.toastService.error('Connexion impossible.');
      loading.dismiss();
      this.navController.navigateBack('/');
    });

  }

}
